import { z } from "zod";

export const seanceDtoSchema = z.object({
  id: z.number(),
  innizRef: z.string().nullable(),
  title: z.string(),
  objectif: z.string().nullable(),
  premium: z.boolean().nullable(),
  duration: z.string().nullable(),
  level: z.string().nullable(),
  participants: z.number().nullable(),
  remote: z.boolean(),
  onsite: z.boolean(),
  active: z.boolean(),
  validated: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string(),
  techniques: z.any().optional(), //techniquesDtoSchema.optional(),
  userId: z.number().nullable(),
  note: z.string().nullable(),
  isInniz: z.boolean().optional(),
  folders: z
    .array(
      z.object({ folderId: z.number(), folderSeanceId: z.number().optional() })
    )
    .optional(),
  timing: z.string().nullable().optional(),
});

export const seancesDtoSchema = z.array(seanceDtoSchema);
